import { createIcon } from '../createIcon';
import { ReactComponent as IconTag } from '../svg/tag.svg';

export default createIcon(IconTag);
